<template>
  <div
    class="overlay"
    @click.self="$emit('fechar')"
  >
    <div class="modal-filtros">
      <div class="modal-header">
        <span>Filtros Ação</span>
        <button
          class="btn-fechar"
          @click="$emit('fechar')"
        >
          ✕
        </button>
      </div>

      <div class="modal-corpo">
        <div class="coluna">
          <p class="coluna-titulo">Unidade:</p>
          <select
            v-model="filtros.unidadeId"
            class="select-unidade"
            :class="{
              selecionado:
                filtros.unidadeId !== null && filtros.unidadeId !== '',
            }"
          >
            <option :value="null">Todas as unidades</option>
            <option
              v-for="unidade in unidades"
              :key="unidade.id"
              :value="unidade.id"
            >
              {{ unidade.nome }}
            </option>
          </select>
        </div>
      </div>

      <div class="modal-rodape">
        <button
          class="btn-limpar"
          @click="limparFiltros"
        >
          Limpar filtros
        </button>
        <button
          class="btn-filtrar"
          @click="aplicarFiltros"
        >
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import unidadesService from "@/service/unidadesService";

const props = defineProps({
  filtrosIniciais: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["fechar", "aplicarFiltros"]);

const unidades = ref([]);

const filtros = ref({
  unidadeId: props.filtrosIniciais?.unidadeId || null,
});

onMounted(async () => {
  try {
    const lista = await unidadesService.getAllUnidades(0, 1000);
    if (lista && Array.isArray(lista)) {
      unidades.value = lista;
    }
  } catch (e) {
    console.error("Erro ao carregar unidades:", e);
  }
});

function limparFiltros() {
  filtros.value = { unidadeId: null };
  emit("aplicarFiltros", { unidadeId: null });
  emit("fechar");
}

function aplicarFiltros() {
  emit("aplicarFiltros", { ...filtros.value });
  emit("fechar");
}
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-filtros {
  background: var(--branco);
  border-radius: 12px;
  width: auto;
  min-width: 400px;
  max-width: 95vw;
  overflow: hidden;
  box-shadow: 0 8px 32px var(--preto);
}

.modal-header {
  background: var(--roxo-escuro2);
  color: var(--branco);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 20px;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
}

.btn-fechar {
  position: absolute;
  right: 14px;
  background: transparent;
  border: 2px solid var(--branco);
  color: var(--branco);
  border-radius: 6px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-corpo {
  display: flex;
  flex-direction: column;
  padding: 28px 24px;
  background: var(--branco);
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.coluna-titulo {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--preto);
  margin-bottom: 4px;
}

.select-unidade {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d0c8e0;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  background: #fff;
  cursor: pointer;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.select-unidade:focus {
  border-color: var(--roxo-escuro2);
  box-shadow: 0 0 0 3px rgba(86, 53, 120, 0.15);
}

.modal-rodape {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px;
  background: var(--branco);
}

.btn-limpar {
  border: 2px solid var(--roxo-claro);
  background: var(--branco);
  color: var(--roxo-claro);
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-limpar:hover {
  background: #f8f6fc;
}

.btn-filtrar {
  background: var(--roxo-claro);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-filtrar:hover {
  opacity: 0.9;
}

.select-unidade.selecionado {
  border-color: #3b2078 !important;
  background-color: hsl(255, 50%, 97%) !important;
  color: #3b2078 !important;
  font-weight: 600 !important;
  box-shadow: 0 0 0 3px rgba(59, 32, 120, 0.08) !important;
}
</style>
